import React from 'react';
import { CardActions } from 'material-ui/Card';
import { ListButton, EditButton, DeleteButton } from '../button';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const ShowActions = ({ basePath, editPath = '', data, hasDelete, hasEdit }) => {
  let linkTo = `${basePath}${basePath[basePath.length - 1] === '/' ? '' : '/'}:id/`;
  if (basePath === '/advanced_function/reminder_config/') {
    linkTo = `${linkTo}${editPath}`;
  }
  return (
    <CardActions style={cardActionStyle}>
      {!!hasEdit && (
        <EditButton linkTo={linkTo} record={data} />
      )}

      <ListButton basePath={basePath} />
      
      {!!hasDelete && (
        <DeleteButton basePath={basePath} record={data} />
      )}
    </CardActions>
  );
}

export default ShowActions;



// WEBPACK FOOTER //
// ./src/components/detail/ShowActions.js